import { createSlice } from "@reduxjs/toolkit";
import { getBomList } from "../../reduxApi/admin/BomReduxApi";

const bomSlice = createSlice({
    name: 'bom',
    initialState: {
        status: 'idle',
        isFiltered: false,
        bom: [],
        error: null,
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;

            console.log('Filtered status set to:', state.isFiltered);
        },
        deleteBomAction: (state, action) => {
    // Add safety check for state.client
    if (!state.client || !Array.isArray(state.client)) {
        return;
    }
    
    action.payload.forEach((id) => {
        const index = state.client.findIndex((item) => item.ROWID === id);
        if (index !== -1) {
            state.client.splice(index, 1);
        }
    });
},


updateBomAction: (state, action) => {
    console.log("action.payload", action.payload)

    if (!state.bom) {
        state.bom = []
        return // Exit early since there's nothing to update
    }
    
    const index = state.bom.findIndex((item) => item.ROWID === action.payload.id)
    if (index !== -1) {
        state.bom.splice(index, 1, action.payload)
    }
},
      

        addBomAction: (state, action) => {
  console.log("action--->", action.payload);
  
  const temp = action.payload;
  console.log("temp", temp);
  temp.ROWID = action.payload.ROWID;
  console.log("temp.ROWID", temp.ROWID);
  
  // Add safety check
  if (!state.bom) {
    state.bom = [];
  }
  
  state.bom.unshift(temp); // Add new data at beginning of array 
}
    },
    extraReducers: (builder) => {
        builder.addCase(getBomList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getBomList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("action.payload",action.payload);
                state.bom = action.payload.bom;
                console.log("state.bom",state.bom);
                
            })
    }
})
export const { deleteBomAction, updateBomAction, addBomAction, setFilteredStatus } = bomSlice.actions
export default bomSlice.reducer